import { useTranslation } from "react-i18next";
import { InfoText } from "../../core/components/texts/InfoText";
import { getSoleConfigPracticeName } from "../../core/store/chainSlice";
import { useMainStore } from "../../core/store/mainStore";
import { useWidgetConfig } from "../../widget/WidgetContext";
import { AppointmentScreenWrapper } from "../onboarding/AppointmentScreenWrapper";
import { useNavigateToReturnUrl } from "./utils/useNavigateToReturnUrl";

/**
 * PF-5480: dead end for a chain without a single bookable practice (reception not booked, or every location
 * hidden). Deliberately without a timed redirect — no path in the flow can lead to a bookable appointment,
 * and redirecting to the practice selection would bounce back and forth with its guard. Recovery is not the
 * point here; leaving is, so the only actions are returning to the practice's website or closing the widget.
 */
export const AppointmentUnavailableScreen = () => {
  const { t } = useTranslation();
  const { onClose: closeWidget } = useWidgetConfig();
  const { appointmentReturnUrl, navigateToReturnUrl, returnButtonText } =
    useNavigateToReturnUrl();
  const practiceName = useMainStore(getSoleConfigPracticeName);

  const leave = () => {
    if (closeWidget) {
      closeWidget();
    } else {
      navigateToReturnUrl();
    }
  };

  return (
    <AppointmentScreenWrapper
      onNext={leave}
      nextButtonText={appointmentReturnUrl ? returnButtonText : undefined}
      hideNextButton={!appointmentReturnUrl && !closeWidget}
      hideBackButton>
      <InfoText
        headline={t("APPOINTMENT_UNAVAILABLE_HEADLINE")}
        text={[
          practiceName
            ? t("APPOINTMENT_UNAVAILABLE_DESCRIPTION_PRACTICE", {
                practiceName,
              })
            : t("APPOINTMENT_UNAVAILABLE_DESCRIPTION"),
          ...(!appointmentReturnUrl && !closeWidget
            ? [t("CLOSE_WINDOW_TEXT")]
            : []),
        ]}
      />
    </AppointmentScreenWrapper>
  );
};
